@if (!destroying) {
  <div [@slideIn] [@slideOut] [@fadeIn]>
    <div
      [ngClass]="status"
      (mouseenter)="onMouseEnter()"
      (mouseleave)="onMouseLeave()"
      class="notification"
    >
      {{ message | translate }}
      <span
        (click)="onCloseNotificationClick()"
        class="notification__close myre-icon-close"
      ></span>
    </div>
  </div>
}
